import InAppNotificationService from '@/services/InAppNotificationService'
import WorktimeReminder from '@/components/notification-panels/WorktimeReminder.vue'

export default function () {
  InAppNotificationService.registerRenderComponent('WORKTIMEREMINDER', WorktimeReminder)
}
